import React, { useState, useEffect } from 'react';
import { Card, CardContent } from './ui/card';
import { ShoppingBag } from 'lucide-react';
import { resolveImageUrl } from '../lib/media';

const TrendingProducts = ({ language }) => {
  const staticProducts = [
    {
      image: 'https://images.unsplash.com/photo-1595950653106-6c9ebd614d3a?q=80&w=800',
      title: language === 'en' ? 'Nike Air Force 1' : 'Nike Air Force 1',
      category: language === 'en' ? 'Sneakers' : 'Zapatillas',
      store: 'Nike',
      storeUrl: 'https://www.nike.com/w/mens-shoes-nik1zy7ok'
    },
    {
      image: 'https://images.unsplash.com/photo-1552346154-21d32810aba3?q=80&w=800',
      title: language === 'en' ? 'Air Jordan 1' : 'Air Jordan 1',
      category: language === 'en' ? 'Basketball Shoes' : 'Zapatos de Baloncesto',
      store: 'Nike',
      storeUrl: 'https://www.nike.com/w/jordan-shoes-37eefzy7ok'
    },
    {
      image: 'https://images.unsplash.com/photo-1648447272271-1c2292144c50?q=80&w=800',
      title: language === 'en' ? 'Wireless Earbuds' : 'Auriculares Inalámbricos',
      category: language === 'en' ? 'Electronics' : 'Electrónica',
      store: 'Amazon',
      storeUrl: 'https://www.amazon.com/s?k=wireless+earbuds'
    },
    {
      image: 'https://images.unsplash.com/photo-1665860455418-017fa50d29bc?q=80&w=800',
      title: language === 'en' ? 'Smart Watch' : 'Reloj Inteligente',
      category: language === 'en' ? 'Wearable Tech' : 'Tecnología Portátil',
      store: 'Amazon',
      storeUrl: 'https://www.amazon.com/s?k=smart+watch'
    },
    {
      image: 'https://images.unsplash.com/photo-1589256469067-ea99122bbdc4?q=80&w=800',
      title: language === 'en' ? 'Bluetooth Speaker' : 'Altavoz Bluetooth',
      category: language === 'en' ? 'Audio' : 'Audio',
      store: 'Amazon',
      storeUrl: 'https://www.amazon.com/s?k=bluetooth+speaker'
    },
    {
      image: 'https://images.unsplash.com/photo-1593830566460-2464575a9a24?q=80&w=800',
      title: language === 'en' ? 'Stylish Phone Cases' : 'Fundas de Teléfono',
      category: language === 'en' ? 'Accessories' : 'Accesorios',
      store: 'Amazon',
      storeUrl: 'https://www.amazon.com/s?k=phone+cases'
    },
    {
      image: 'https://images.unsplash.com/photo-1766928102358-86e329eef03b?q=80&w=800',
      title: language === 'en' ? 'Designer Sunglasses' : 'Gafas de Sol',
      category: language === 'en' ? 'Fashion' : 'Moda',
      store: 'Amazon',
      storeUrl: 'https://www.amazon.com/s?k=women+sunglasses'
    },
    {
      image: 'https://images.unsplash.com/photo-1665860455450-21fb3949de29?q=80&w=800',
      title: language === 'en' ? 'Fitness Tracker' : 'Monitor de Fitness',
      category: language === 'en' ? 'Health & Fitness' : 'Salud y Fitness',
      store: 'Amazon',
      storeUrl: 'https://www.amazon.com/s?k=fitness+tracker'
    },
    {
      image: 'https://images.unsplash.com/photo-1761574028262-6d834741bfd8?q=80&w=800',
      title: language === 'en' ? 'Elegant Black Gown' : 'Vestido Negro Elegante',
      category: language === 'en' ? 'Evening Wear' : 'Ropa de Noche',
      store: 'SHEIN',
      storeUrl: 'https://www.shein.com/Women-Dresses-c-1727.html'
    },
    {
      image: 'https://images.unsplash.com/photo-1764998112464-f293be747d84?q=80&w=800',
      title: language === 'en' ? 'Dramatic Evening Dress' : 'Vestido de Noche Dramático',
      category: language === 'en' ? 'Formal Dresses' : 'Vestidos Formales',
      store: 'SHEIN',
      storeUrl: 'https://www.shein.com/Women-Dresses-c-1727.html'
    },
    {
      image: 'https://images.unsplash.com/photo-1754299257780-71fd1f741cf2?q=80&w=800',
      title: language === 'en' ? 'Floral Dress' : 'Vestido Floral',
      category: language === 'en' ? 'Dresses' : 'Vestidos',
      store: 'SHEIN',
      storeUrl: 'https://www.shein.com/Women-Dresses-c-1727.html'
    },
    {
      image: 'https://images.unsplash.com/photo-1621996659490-3275b4d0d951?q=80&w=800',
      title: language === 'en' ? 'Peep Toe Heels' : 'Tacones Abiertos',
      category: language === 'en' ? 'High Heels' : 'Tacones Altos',
      store: 'SHEIN',
      storeUrl: 'https://www.shein.com/Women-Heels-c-2095.html'
    },
    {
      image: 'https://images.unsplash.com/photo-1534653299134-96a171b61581?q=80&w=800',
      title: language === 'en' ? 'Yellow Strap Heels' : 'Tacones Amarillos con Tira',
      category: language === 'en' ? 'High Heels' : 'Tacones Altos',
      store: 'SHEIN',
      storeUrl: 'https://www.shein.com/Women-Heels-c-2095.html'
    },
    {
      image: 'https://images.unsplash.com/photo-1760473004054-eb0fd50ea9ae?q=80&w=800',
      title: language === 'en' ? 'Red Bow Heels' : 'Tacones Rojos con Lazo',
      category: language === 'en' ? 'High Heels' : 'Tacones Altos',
      store: 'SHEIN',
      storeUrl: 'https://www.shein.com/Women-Heels-c-2095.html'
    },
    {
      image: 'https://images.unsplash.com/photo-1764179690182-79465d8d4161?q=80&w=800',
      title: language === 'en' ? 'Designer Handbag' : 'Bolso de Diseño',
      category: language === 'en' ? 'Accessories' : 'Accesorios',
      store: 'SHEIN',
      storeUrl: 'https://www.shein.com/Women-Bags-c-1764.html'
    },
    {
      image: 'https://images.unsplash.com/photo-1755537131397-66ef374269de?q=80&w=800',
      title: language === 'en' ? 'Pearl Clutch Bag' : 'Bolso de Perlas',
      category: language === 'en' ? 'Evening Bags' : 'Bolsos de Noche',
      store: 'SHEIN',
      storeUrl: 'https://www.shein.com/Women-Bags-c-1764.html'
    },
    {
      image: 'https://images.unsplash.com/photo-1726194158976-0a6d69d81c13?q=80&w=800',
      title: language === 'en' ? 'Evening Dress' : 'Vestido de Noche',
      category: language === 'en' ? 'Party Wear' : 'Ropa de Fiesta',
      store: 'SHEIN',
      storeUrl: 'https://www.shein.com/Women-Dresses-c-1727.html'
    },
    {
      image: 'https://images.unsplash.com/photo-1650591038434-649e2ce3915c?q=80&w=800',
      title: language === 'en' ? 'Casual Chic' : 'Casual Elegante',
      category: language === 'en' ? 'Streetwear' : 'Ropa Urbana',
      store: 'SHEIN',
      storeUrl: 'https://www.shein.com/Women-Clothing-c-2030.html'
    },
    {
      image: 'https://images.pexels.com/photos/996329/pexels-photo-996329.jpeg?auto=compress&cs=tinysrgb&w=800',
      title: language === 'en' ? 'Fashion Collections' : 'Colecciones de Moda',
      category: language === 'en' ? 'Clothing' : 'Ropa',
      store: 'Zara',
      storeUrl: 'https://www.zara.com/us/en/woman-new-in-l1180.html'
    },
    {
      image: 'https://images.unsplash.com/photo-1608667508764-33cf0726b13a?q=80&w=800',
      title: language === 'en' ? 'Running Shoes' : 'Zapatos para Correr',
      category: language === 'en' ? 'Athletic' : 'Deportivo',
      store: 'Adidas',
      storeUrl: 'https://www.adidas.com/us/women-shoes'
    },
    {
      image: 'https://images.pexels.com/photos/322207/pexels-photo-322207.jpeg?auto=compress&cs=tinysrgb&w=800',
      title: language === 'en' ? 'Men\'s Fashion' : 'Moda para Hombres',
      category: language === 'en' ? 'Accessories' : 'Accesorios',
      store: 'Fashion Nova',
      storeUrl: 'https://www.fashionnova.com/collections/mens-new-arrivals'
    },
    {
      image: 'https://images.pexels.com/photos/2529148/pexels-photo-2529148.jpeg?auto=compress&cs=tinysrgb&w=800',
      title: language === 'en' ? 'Casual Sneakers' : 'Zapatillas Casuales',
      category: language === 'en' ? 'Footwear' : 'Calzado',
      store: 'Amazon',
      storeUrl: 'https://www.amazon.com/s?k=women+sneakers'
    }
  ];

  const [apiProducts, setApiProducts] = useState(null);

  useEffect(() => {
    let active = true;
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/products`)
      .then((res) => res.json())
      .then((data) => {
        if (active && Array.isArray(data) && data.length > 0) setApiProducts(data);
      })
      .catch(() => {});
    return () => { active = false; };
  }, []);

  const products = apiProducts
    ? apiProducts.map((p) => ({
        image: resolveImageUrl(p.image),
        title: language === 'en' ? p.title_en : (p.title_es || p.title_en),
        category: language === 'en' ? p.category_en : (p.category_es || p.category_en),
        store: p.store,
        price: p.price || '',
        storeUrl: p.store_url
      }))
    : staticProducts;

  const orderOnWhatsApp = (product) => {
    const storeText = product.store ? ` (${product.store})` : '';
    const priceText = product.price ? ` - ${product.price}` : '';
    const msg =
      language === 'en'
        ? `Hi Athena's! I'd like to order this product: ${product.title}${storeText}${priceText}. Is it available?\n\nItem photo: ${product.image}`
        : `¡Hola Athena's! Me gustaría ordenar este producto: ${product.title}${storeText}${priceText}. ¿Está disponible?\n\nFoto del artículo: ${product.image}`;
    window.open(`https://wa.me/5016735717?text=${encodeURIComponent(msg)}`, '_blank');
  };

  return (
    <section className="py-20 px-4 bg-gradient-to-b from-white to-[#f7f5f2]">
      <div className="container mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-[#1e1919] mb-4">
            {language === 'en' ? 'Trending Products' : 'Productos Populares'}
          </h2>
          <p className="text-lg text-[#736c64] max-w-2xl mx-auto">
            {language === 'en' 
              ? 'Discover the latest trending items from our partner stores' 
              : 'Descubre los artículos más populares de nuestras tiendas asociadas'}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {products.map((product, index) => (
            <Card 
              key={index}
              className="group overflow-hidden border-2 border-transparent hover:border-[#8b1538]/30 transition-all transform hover:scale-105 hover:shadow-2xl"
            >
              <div className="relative overflow-hidden aspect-square">
                <img 
                  src={resolveImageUrl(product.image)}
                  alt={product.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </div>
              <CardContent className="p-6">
                <div className="flex items-center justify-between mb-2">
                  <span className="text-sm font-semibold text-[#8b1538] uppercase tracking-wide">
                    {product.store}
                  </span>
                  <span className="text-xs text-[#736c64] bg-[#fad24b]/20 px-3 py-1 rounded-full">
                    {product.category}
                  </span>
                </div>
                <h3 className="text-xl font-bold text-[#1e1919] mb-2">
                  {product.title}
                </h3>
                {product.price && (
                  <p className="text-lg font-extrabold text-[#8b1538] mb-1" data-testid={`product-price-${index}`}>{product.price}</p>
                )}
                <p className="text-sm text-[#736c64]">
                  {language === 'en' 
                    ? 'Available for order through Athena\'s' 
                    : 'Disponible para ordenar con Athena\'s'}
                </p>
                <button
                  type="button"
                  onClick={() => orderOnWhatsApp(product)}
                  data-testid={`product-order-${index}`}
                  className="mt-4 w-full inline-flex items-center justify-center gap-2 rounded-lg bg-[#25D366] hover:bg-[#1eb257] text-white font-semibold py-2 transition-colors"
                >
                  <ShoppingBag className="w-4 h-4" />
                  {language === 'en' ? 'Order on WhatsApp' : 'Ordenar por WhatsApp'}
                </button>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-[#736c64] text-lg">
            {language === 'en' 
              ? 'Want something else? We can get it for you!' 
              : '¿Quieres algo más? ¡Podemos conseguirlo para ti!'}
          </p>
        </div>
      </div>
    </section>
  );
};

export default TrendingProducts;
